<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { useCanonicalRoute } from '@shared/lib/routes'
import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'TutorKanbanDetailHeader',
})

const route = useRoute()
const tutorId = route.params.id as string

const { canonicalUrl } = useCanonicalRoute({ key: 'tutor-kanban-referrer' })

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'tutor-kanban',
    text: 'Tutor kanban',
    to: canonicalUrl.value ?? AppRoute.TutorKanbanOnboarding,
    disabled: false,
  },
  {
    id: 'tutor-detail',
    text: `Tutor/${tutorId}`,
    to: null,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
